export class ControlBreadcrumbModel {
    constructor({label, getLabel, isShow = true}) {
        this.label = label;
        this.isShow = isShow;

        if(getLabel) {
            this.getLabel = getLabel.bind(this);
        }
    }
}